import { trackEvent } from '@/app/analytics/track.ts';
import toast from '@/app/toast.ts';
import type { AccountRepresentativeListModel } from '@/app/types/account-representative.type.ts';
import { RepresentativeStatusEnum } from '@/app/types/representative-status.type.ts';
import { usePatchRejectAccountRepresentativeMutation } from '@/slices/account-representative-api-slice.ts';

export const useRejectAccountRepresentative = () => {
  const [patchReject, { isLoading: isRejecting }] = usePatchRejectAccountRepresentativeMutation();

  const rejectConnection = async (data: AccountRepresentativeListModel) => {
    const isApproved = data.representativeStatus?.id === RepresentativeStatusEnum.Approved;

    try {
      await patchReject(data.key).unwrap();
      trackEvent('connection_rejected', {
        account_representative_key: data.key,
        account_key: data.accountKey,
        account_id: data.accountId,
        representative_key: data.representativeKey,
      });
      toast.success(isApproved ? 'Connection removed.' : 'Representative rejected.');
    } catch {
      toast.error(
        isApproved ? 'Could not remove this connection.' : 'Could not reject this representative.',
      );
      throw new Error('Failed to reject account representative');
    }
  };

  return { rejectConnection, isRejecting };
};
